// Per-panel help data registry.
//
// Each entry is the static copy that travels with a simulator: its
// welcome card, hotspot annotations, and keyboard shortcuts. New
// panels populate their entry; the help button only appears when the
// entry has at least one hotspot or a welcome card present.
//
// PR 1 lands all panels with empty data — visually identical to today.
// PR 2 fills `crossover-solo` with real annotations.

import type { PanelHelpData, PanelKind } from "./help-types";
import { CROSSOVER_SOLO_HELP } from "../simulators/help-data/crossover-solo";
import { PTZ_AW_RP50_HELP } from "../simulators/help-data/ptz-aw-rp50";
import { TELEX_BP_1002_HELP } from "../simulators/help-data/telex-bp-1002";

const empty: PanelHelpData = { hotspots: [], shortcuts: [] };

export const HELP_DATA: Readonly<Record<PanelKind, PanelHelpData>> = {
  "crossover-solo": CROSSOVER_SOLO_HELP,
  "ptz-aw-rp50": PTZ_AW_RP50_HELP,
  "telex-bp-1002": TELEX_BP_1002_HELP,
};

export function getHelpData(kind: PanelKind): PanelHelpData {
  return HELP_DATA[kind] ?? empty;
}

export function helpHasContent(kind: PanelKind): boolean {
  const d = getHelpData(kind);
  return d.hotspots.length > 0 || !!d.welcome || d.shortcuts.length > 0;
}
